import classNames from 'classnames'

interface DocumentFileIconProps {
  contentType?: string
  className?: string
}

const getIconClassName = (contentType?: string) => {
  switch (contentType) {
    case 'application/pdf':
      return 'bi-filetype-pdf'
    case 'image/png':
      return 'bi-filetype-png'
    case 'image/jpeg':
    case 'image/jpg':
      return 'bi-filetype-jpg'
    default:
      return 'bi-file-earmark'
  }
}

export const DocumentFileIcon: React.FC<DocumentFileIconProps> = ({ contentType, className }) => {
  const iconClassName = getIconClassName(contentType)

  return <i className={classNames('bi', iconClassName, className)} />
}
